import GameCard from "@/components/GameCard/GameCard";
import { SearchType } from "../../types";

import st from "./index.module.scss";
import ItemsListSearch from "../items-list";
import ProviderCard from "@/components/ProviderCard";
import NotFoundSearch from "../not-found";
import HeaderBackSearch from "../header-back";
import { useTranslations } from "next-intl";

export default function SearchResult({
  result,
  deleteValue,
}: {
  deleteValue: () => void;
  result: SearchType;
}) {
  const t = useTranslations("SearchModal");

  const isEmpty = result.games.length === 0 && result.providers.length === 0;
  if (isEmpty) {
    return <NotFoundSearch />;
  }
  return (
    <div className={`${st.search_content__result}`}>
      <HeaderBackSearch deleteValue={deleteValue} />
      <div className={`${st.search_result__wrap}`}>
        <div className={`${st.search_result__inner}`}>
          {result.providers.length > 0 && (
            <div className={`${st.search_result_wrap}`}>
              <div className={`${st.search_result__header}`}>
                <div className={`${st.search_result__header_title}`}>
                  <div className={`${st.search_result__header_title_text}`}>{t("providers")}</div>
                  <div className={`${st.search_result__header_title_number}`}>
                    {result.providers.length || 0}
                  </div>
                </div>
              </div>
              <div className={`${st.search_result__list} two-row`}>
                <ItemsListSearch items={result.providers} Cart={ProviderCard} />
              </div>
            </div>
          )}
          <div className={`${st.search_result_wrap}`}>
            <div className={`${st.search_result__header} search_result__header--recommendation`}>
              <div className={`${st.search_result__header_title}`}>
                <div className={`${st.search_result__header_title_text}`}>{t("games")}</div>
                <div className={`${st.search_result__header_title_number}`}>
                  {result.games.length || 0}
                </div>
              </div>
            </div>
            <div className={`${st.search_result__list} two-row`}>
              <ItemsListSearch items={result.games} Cart={GameCard} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
